import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';

import {AlertService, AuthenticationService} from './index';

import {saveAs as importedSaveAs} from "file-saver";

import {LoginHelper} from '../helpers';
import {catchError, map} from "rxjs/operators";
import {Load} from "../_decorators/loading.decorator";
import {of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {AbstractFileManagerApiService} from "../external/angular2-filemanager/store/fileManagerApiAbstract.class";
import {IFileManagerApi} from "../external/angular2-filemanager/store/IFileManagerApi";
import {
  FileManagerConfiguration
} from "../external/angular2-filemanager/configuration/fileManagerConfiguration.service";
import {IOuterNode} from "../external/angular2-tree/interfaces/IOuterNode";
import {IOuterFile} from "../external/angular2-filemanager/filesList/interface/IOuterFile";
import {IFileDataProperties} from "../external/angular2-filemanager/services/imageDataConverter.service";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class FileManagerBackendApiService1 extends AbstractFileManagerApiService implements IFileManagerApi {

  public constructor(public $http: HttpClient,
                     public configuration: FileManagerConfiguration,
                     public authenticationService: AuthenticationService,
                     public alertsService: AlertService,
                     public config: IndexConfigService) {

    super();

    this.nodes = [];
    this.files = [];
  }

  /**
   * Load folder chidls for given folder id
   *
   * @param {string} nodeId
   * @returns {Observable<IOuterNode[]>}
   */

  public load(nodeId: string): Observable<IOuterNode[]> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    //console.log(this.configuration);

    const nodeIds = this.nodes.map((node: IOuterNode) => node.id);
    return this.$http.get<any>(
      this.config.api + '/api/documents/foldersAll' + (nodeId ? ('?dirId=' + encodeURIComponent(nodeId)) : ''))
      .pipe(map((response: any): IOuterNode[] => {
          return response;
        }),
        map((nodes: IOuterNode[]) => {
          nodes.forEach((node: IOuterNode) => {
            node.treeId = '';
            if (nodeIds.indexOf(node.id) === -1) {
              this.nodes.push(node);
            } else {
              const index = this.nodes.findIndex((item: IOuterNode) => node.id === item.id);
              this.nodes[index] = node;
            }
          });
          return nodes;
        }));
  }

  /**
   * Load folder chidls for given folder id
   *
   * @param {string} nodeId
   * @returns {Observable<IOuterNode[]>}
   */

  public downloadAsZip(nodeId: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.$http.get<string>(this.config.api + '/api/documents/zip/create?path=' + nodeId)
      .subscribe(res => {
        window.location.href = this.config.api + '/api/documents/zip/download?id=' + (<any>res).id + "&token=" + LoginHelper.getFileToken();
      });
  }

  /**
   * Create new folder
   *
   * @param {IOuterNode} node
   * @param {string} parentNodeId
   * @returns {Observable<IOuterNode>}
   */
  @Load()
  public add(node: IOuterNode, parentNodeId: string): Observable<IOuterNode> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    const data = {
      node: node,
      parentNodeId: parentNodeId
    };

    return this.$http.post<any>(this.config.api + '/api/documents/addFolder', data)
      .pipe(
        catchError(e => {
          this.alertsService.error(e.message)
          return of(null);
        }))
      .pipe(
        map((res: any): IOuterNode => {
          if (res) {
            let newNode = res;
            this.nodes.push(newNode);
            return newNode;
          }
          return null;
        }));

  }

  /**
   * Move folder from source parent to target parent
   *
   * @param {IOuterNode} srcNode
   * @param {IOuterNode} targetNode
   * @returns {Observable<IOuterNode>}
   */
  @Load()
  public move(srcNode: IOuterNode, targetNode: IOuterNode | null): Observable<IOuterNode> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    const srcId = srcNode.id;
    const targetId = targetNode ? targetNode.id : null;


    //return this.$http.put(this.config.api + '/api/documents/moveFolder', {source: srcId, target: targetId})
    return this.$http.put(this.config.api + '/api/documents/moveFolder', {
      source: srcNode,
      target: targetNode
    })
      .pipe(map((res: any) => {
          return res;
        }),
        map((movedNode: IOuterNode) => {
          const index = this.findIndexByNodeId(srcId);
          //this.nodes[index].parentId = targetId;

          return movedNode;
        }));
  }

  /**
   * Update folder name
   *
   * @param {IOuterNode} node
   * @returns {Observable<IOuterNode>}
   */
  @Load()
  public update(node: IOuterNode): Observable<IOuterNode> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.$http.put(this.config.api + '/api/documents/updateFolder', node)
      .pipe(map((res: any) => {
        const newNode = res;
        const index = this.findIndexByNodeId(node.id);

        this.nodes[index]/*.name*/ = newNode/*.name*/;

        return newNode;
      }));
  }

  public renameFile(src: IOuterNode, targetId: string): Observable<IOuterNode> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.$http.put(this.config.api + '/api/documents/folderMove/file', {
      source: src.id,
      target: targetId
    })
      .pipe(
        map((movedNode: IOuterNode) => {
          return movedNode;
        })
      );
  }


  /**
   * Remove node by given id
   *
   * @param {string} nodeId
   * @returns {Observable<IOuterNode>}
   */
  @Load()
  public remove(nodeId: string): Observable<IOuterNode> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    const index = this.findIndexByNodeId(nodeId);

    const hasChildren = false;//this.getChildren(nodeId).length > 0;

    const node = this.nodes[index];

    if (!hasChildren) {
      // TODO: use 'delete' instead of use 'put' request here!
      //return this.$http.delete(this.config.api + '/api/documents/deleteFolder', {body: {node: node}})
      return this.$http.put(this.config.api + '/api/documents/deleteFolder', node)
        .pipe(map((res: any) => {
          const removedNode = res;
          this.nodes.splice(index, 1);

          return removedNode;
        }));
    } else {
      return throwError('Node is not empty');
    }
  }

  /**
   * Load files from directory
   *
   * @param {string} nodeId
   * @returns {Observable<IOuterFile[]>}
   */
  public loadFiles(nodeId = ''): Observable<IOuterFile[]> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }
    nodeId = nodeId || '';
    this.currentNodeId = nodeId.split(':')[0];

    return this.$http.get<any>(this.config.api + '/api/documents/filesAll' + '?dirId=' + encodeURIComponent(nodeId))
      .pipe(map((response: any): IOuterFile[] => {
          return response;
        }),
        map((files: IOuterFile[]) => {
          this.files = files.map((file: IOuterFile) => <IFileDataProperties>file);

          return files;
        }))
  }

  /**
   * Load files from directory
   *
   * @param {string} nodeId
   * @returns {Observable<IOuterFile[]>}
   */
  public loadFilesWithPermanentTokens(nodeId = '', trustReportId): Observable<IOuterFile[]> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }
    nodeId = nodeId || '';
    this.currentNodeId = nodeId.split(':')[0];

    return this.$http.get<any>(this.config.api + '/api/documents/filesAll/permanentToken' + '?dirId=' + encodeURIComponent(nodeId) + '&trustReportId=' + trustReportId)
      .pipe(map((response: any): IOuterFile[] => {
          return response;
        }),
        map((files: IOuterFile[]) => {
          this.files = files.map((file: IOuterFile) => <IFileDataProperties>file);

          return files;
        }))
  }

  public downloadFile(file: IOuterFile): Observable<IOuterFile> {

    var tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    this.$http
      .get(this.config.api + '/api/documents/downloadFile', {params: <any>file, responseType: 'arraybuffer'})
      .subscribe(res => {
        importedSaveAs(new Blob([res]), file.name);

        //console.log(file);
        return of(new Blob([res]));
      });
    //.catch(this.handleError);

    return of(file);
  }

  /**
   * Remove file from folder
   *
   * @param {IOuterFile} file
   * @returns {Observable<boolean>}
   */
  @Load()
  public removeFile(file: IOuterFile): Observable<boolean> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    const index = this.findIndexByFileId(file.id.toString());

    if (index === -1) {
      return of(false);
    }
    /*
        const params = new URLSearchParams();
        params.set('id', file.id.toString());
        */

    // TODO: use 'delete' instead of use 'put' request here!
    //return this.$http.delete(this.config.api + '/api/documents/deleteFile', {search: params})
    return this.$http.put(this.config.api + '/api/documents/deleteFile', file)
      .pipe(map((res: Response) => {
        this.files.splice(index, 1);

        return true;
      }));
  }

  @Load()
  public removeSelectedFiles(selectedFiles: string[]) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    const params = new URLSearchParams();
    params.set('id', selectedFiles.join('|'));

    // TODO: use 'delete' instead of use 'put' request here!
    //return this.$http.delete(this.configuration.fileUrl, {search: params})
    return this.$http.put(this.config.api + '/api/documents/deleteSelectedFiles', {search: params})
      .pipe(map((res: Response) => {
        selectedFiles.forEach((fileId: string) => {
          const index = this.findIndexByFileId(fileId);

          if (index > -1) {
            this.files.splice(index, 1);
          }
        });

        return true;
      }));
  }


  /**
   * This method is success method, real upload is done in ExtendedFileUploader
   * @param {IOuterFile} file
   * @returns {Observable<IOuterFile>}
   */
  @Load()
  public uploadFile(file: IOuterFile): Observable<IOuterFile> {

    /*
    console.log('uploadFile');

    var tenantName = LoginHelper.getTenantName();
    if (tenantName == null){
        this.authenticationService.logout();

        return null;
    }

    let formData = new FormData();

    formData.append(file.name, file.data);

    this.$http
        .post<any>(this.config.api + '/api/documents/addFile', formData, this.jwt())
        ;
*/
    //console.log('uploadFile');
    const fileData = <IFileDataProperties>file;
    this.files.push(fileData);
    /*
        console.log('fileData');
        console.log(fileData);
        console.log(this.files);
        */

    return of(file);
  }

  /**
   * @param {IOuterFile[]} files
   * @param {IOuterNode} node
   * @returns {Observable<IOuterFile[]>}
   */
  @Load()
  public moveFile(files: IOuterFile[], node: IOuterNode): Observable<IOuterFile[]> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    const ids: string[] = files.map(file => file.id.toString());

    return this.$http.put(this.config.api + '/api/documents/moveFile', {
      files: files,
      folder: node
    })
      .pipe(map((res: any) => {
        return res;
      }));
  }

  /**
   * @param {string} nodeId
   * @returns {number}
   */
  public findIndexByNodeId(nodeId: string): number {
    return this.nodes.findIndex((node) => {
      return node.id === nodeId;
    });
  }

  public findNodeByNodeId(nodeId: string): IOuterFile {
    return null;
    //return this.nodes.filter(node => node.id === nodeId)[0];
  }

  /**
   * @param {string} fileId
   * @returns {number}
   */
  public findIndexByFileId(fileId: string): number {
    return this.files.findIndex((file) => file.id === fileId);
  }

  /**
   * @param {string} nodeId
   * @returns {IOuterNode[]}
   */
  public getChildren(nodeId: string): IOuterNode[] {
    return this.nodes.filter((node: IOuterNode) => node.parentId === nodeId);
  }

  /**
   * @param file
   * @returns {{id: string, folderId: string, name: string, thumbnailUrl: string, url: string, width: number, height: number, mime: string}}
   */
  public convertLocalData2IOuterFile(file: IFileDataProperties): IOuterFile {
    return {
      id: file.id,
      folderId: file.folderId,
      lastModified: file.lastModified,
      name: file.name,
      thumbnailUrl: file.data,
      url: file.data,
      width: file.width,
      height: file.height,
      type: file.type,
      size: file.size
    }
  }

  /**
   * @param file
   * @returns {{id: (any|string), folderId: string, name: string, type: string, data: string, size: number}}
   */
  public convertIOuterFile2LocalData(file: IOuterFile): IFileDataProperties {
    return {
      id: file.id.toString(),
      folderId: file.folderId,
      lastModified: file.lastModified,
      name: file.name,
      type: file.type,
      data: file.data,
      size: file.size,
      width: file.width,
      height: file.height
    }
  }
}
